<template>
  <div class="bb-balance-soa-wrapper">
    <transition name="fade" appear>
      <LoaderFly v-if="loaderRun"/>
    </transition>
    <div class="bb-balance-soa">
      <div class="bb-balance-soa-header">
        <h1 class="bb-balance-soa-header-title">
          Inv. {{balanceByInvoices.number}}
        </h1>
      </div>
      <div class="bb-balance-soa-variants">
        <div v-if="defaultStatus.id === 1" class="bb-balance-soa-variants-status">
          <span class="bb-balance-soa-variants-status-circle"/>
          <span class="bb-balance-soa-variants-status-text">
            Balance, AED {{convertNumber(balanceByInvoices.balance) || 0}}
          </span>
          <div class="bb-balance-soa-variants__button"
               @click="openProforma($event)"
               @mouseleave="showPopupCredit = false"
               :class="{'bb-balance-soa-variants__button_disabled': disabledButton || !positiveBalance}"
               ref="creditButton"
          >
            ISSUE CREDIT NOTE
            <transition name="fade" mode="out-in">
              <div v-if="showPopupCredit"
                   class="bb-balance-soa-variants-popup"
              >
                <span class="bb-balance-soa-variants-popup__text">Tax Inv. No. is missing</span>
              </div>
            </transition>
          </div>
          <div class="bb-balance-soa-variants__button"
               @click="openIssueProforma($event)"
               @mouseleave="showPopupProforma = false"
               ref="proformaButton"
               :class="{
                 'bb-balance-soa-variants__button_disabled': disabledButton || disableProforma
               }"
          >
            ISSUE PROFORMA
            <transition name="fade" mode="out-in">
              <div v-if="showPopupProforma"
                   class="bb-balance-soa-variants-popup"
              >
                <span class="bb-balance-soa-variants-popup__text">Tax Inv. No. is missing</span>
              </div>
            </transition>
          </div>
        </div>
        <div v-else class="bb-balance-soa-select">
          <v-select label="name"
                    :options="statusListWithoutOpenBalance"
                    :clearable="false"
                    :searchable="false"
                    :value="currentStatus"
                    @input="setStatus">
            <template #selected-option="{name, id}">
              <span class="bb-balance-soa-select__option"
                    :style="{background: currentStatus.color}">
              </span>
              <span :style="{color: currentStatus.color}">{{ name }}</span>
            </template>
            <template #option="item">
              <span class="bb-balance-soa-select__option"
                    :style="{background: item.color}">
              </span>
              <span :style="{color: item.color}">{{ item.name }}</span>
            </template>
          </v-select>
          <div class="bb-balance-soa-select__warning"
               v-if="statusInvoice.id === 1"
          >
            Note that Invoice was not paid in full.
          </div>
        </div>
        <div class="bb-balance-soa-variants__tax-invoice">
          <span>Tax Inv. No:</span>
          <span :class="{'bb-balance-soa-variants__tax-invoice_color': !balanceByInvoices.taxInvoiceNumber}">
            {{balanceByInvoices.taxInvoiceNumber ? `${balanceByInvoices.taxInvoiceNumber}` : `Not Assigned`}}
          </span>
        </div>
        <div class="bb-balance-soa-variants-received">
          <div class="bb-balance-soa-variants-received__item">
            <span>Received, AED</span>
            <span class="bb-balance-soa-variants-received_text-end">
              {{convertNumber(balanceByInvoices.received) || 0}}
            </span>
          </div>
          <div class="bb-balance-soa-variants-received__item">
            <span>Invoiced, AED</span>
            <span class="bb-balance-soa-variants-received_text-end">
              {{convertNumber(balanceByInvoices.invoiced) || 0}}
            </span>
          </div>
          <div v-if="statusInvoice.id !== 2"
               class="bb-balance-soa-variants-received__due"
          >
            <span>{{statusInvoice.name}}, AED</span>
            <div :class="'bb-balance-soa-variants-received__due_' + getColorByInvoiceStatus()"
            >
             {{convertNumber(balanceByInvoices.due) || 0}}
            </div>
          </div>
        </div>
      </div>
      <div class="bb-balance-soa__line"/>
      <TableBalance :rows="balanceList"
                    @openProforma="openInvoiceProforma"
                    @openBalanceLink="openBalanceLink"
      />
      <div class="bb-balance-soa-button" v-if="changedStatus">
        <button class="bb-balance-soa-button-size
                       bb-button"
                @click.stop="saveBalance"
        >
          SAVE
        </button>
      </div>
    </div>
    <transition name="fade" mode="out-in">
      <ModalWindow v-if="openConfirmStatus"
                   :table-mode="false"
                   :without-padding="true"
                   :center-title="true"
                   @close="openConfirmStatus = false"
                   :title="confirmTitle"
      >
        <ConfirmStatusSoa @close="openConfirmStatus = false"
                          @save="saveStatus"
        />
      </ModalWindow>
    </transition>
    <transition name="fade" mode="out-in">
      <ModalWindow v-if="proformaOpen" @close="proformaOpen = false">
        <ProformaInvoice :view-mode="true"
                         @close="proformaOpen = false"
                         :editable-invoice="editableInvoice"
        />
      </ModalWindow>
    </transition>
  </div>
</template>

<script>
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import vSelect from 'vue-select'
import BBTable from '@/components/Main/BBTable/BBTable'
import TableBalance from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableBalance/TableBalance'
import {soaStatusList} from '@/constants/soaStatusList'
import ProformaInvoice from '@/components/Dissemination/Sales/CRM/ContactCard/ProformaInvoice/ProformaInvoice'
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'
import ConfirmStatusSoa from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/ConfirmStatusSoa'
import {statusInvoiceList} from '@/constants/statusInvoiceList'
import {FOUNDER} from '@/constants/roles'
import InvoicesApi from '@/api/Invoce/api'
import SoaApi from '@/api/Soa/api'
import _, {get} from 'lodash'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import convertNumber from '@/mixin/convertNumber'
export default {
  name: 'BalanceByInvoices.vue',
  mixins: [convertNumber],
  components: {
    LoaderFly,
    vSelect,
    BBTable,
    ModalWindow,
    ConfirmStatusSoa,
    TableBalance,
    ProformaInvoice,
    VuePerfectScrollbar
  },
  props: ['soaInvoice'],
  data () {
    return {
      loaderRun: false,
      balanceByInvoices: {},
      openConfirmStatus: false,
      statusInvoice: {},
      confirmTitle: 'Are you sure you want to proceed?',
      changedStatus: false,
      soaInvoiceData: {},
      issueProformaServices: [],
      currentStatus: {},
      proformaOpen: false,
      selectStatusSoa: {},
      servicesBalance: [],
      editableInvoice: {
        invoice: {}
      },
      category: 0,
      openPopup: {
        left: 0,
        top: 0
      },
      showPopupCredit: false,
      showPopupProforma: false,
      disabledButton: false,
      statusList: soaStatusList,
      invoiceStatus: statusInvoiceList
    }
  },
  computed: {
    balanceList: {
      get: function () {
        return this.$store.getters.balanceInvoices
      },
      set: function (data) {
        this.$store.dispatch('setBalanceInvoices', data)
      }
    },
    checkBalanceByStatus () {
      const id = get(this.statusInvoice, 'id', 0)
      if (id === 1) {
        return Math.abs(this.balanceByInvoices.balance) === this.balanceByInvoices.due
      }
    },
    disableProforma () {
      return !this.negativeBalance || this.checkBalanceByStatus || !this.issueProformaServices.length
    },
    positiveBalance () {
      return this.servicesBalance.some(item => item.balance > 0)
    },
    negativeBalance () {
      return this.servicesBalance.some(item => item.balance < 0)
    },
    defaultStatus: {
      get: function () {
        const idStatus = get(this.balanceByInvoices, 'soaStatus', 1)
        return this.statusList.find(item => item.id === idStatus)
      }
    },
    statusListWithoutOpenBalance: {
      get: function () {
        const userInfo = this.$store.getters.userInfo
        return this.statusList.filter(item => {
          const isFounder = userInfo.role === FOUNDER.id
          if (isFounder) return item.id !== 1
          return item.id !== 1 && item.id !== 2
        })
      }
    }
  },
  methods: {
    setStatus (item) {
      this.selectStatusSoa = item
      if (this.statusInvoice.id === 1) {
        this.openConfirmStatus = true
        return
      }
      this.currentStatus = item
      this.changedStatus = this.currentStatus.id !== this.defaultStatus.id
    },
    saveStatus () {
      this.currentStatus = this.selectStatusSoa
      this.changedStatus = this.currentStatus.id !== this.defaultStatus.id
      this.openConfirmStatus = false
    },
    setPositionPopup (e, ref) {
      if (ref === 'creditButton') {
        this.showPopupCredit = true
      }
      if (ref === 'proformaButton') {
        this.showPopupProforma = true
      }
      const popups = get(this.$refs, ref, '')
      const popupWidth = get(popups[0], 'offsetWidth', 0)
      const diffLeft = popupWidth / 2
      const box = e.target.getBoundingClientRect()
      this.openPopup = {
        left: (box.left - diffLeft + 5) + 'px',
        top: box.top + 30 + 'px'
      }
    },
    openProforma (e) {
      if (!this.balanceByInvoices.taxInvoiceNumber) {
        this.setPositionPopup(e, 'creditButton')
        return
      }
      if (!this.positiveBalance) return
      this.loaderRun = true
      const invoiceId = get(this.soaInvoice, 'id', '')
      this.$emit('openProforma', invoiceId)
    },
    openInvoiceProforma (event, soa) {
      if (event.target.id === 'description__text') {
        const idInvoice = _.get(soa, 'descriptionInvoice', false)
        if (!idInvoice) return
        this.getInvoiceById(idInvoice)
      }
    },
    openBalanceLink (soa) {
      const idInvoice = _.get(soa, 'id', false)
      if (!idInvoice) return
      this.getInvoiceById(idInvoice)
    },
    getInvoiceById (id) {
      this.loaderRun = true
      InvoicesApi.getInvoiceById(id)
        .then((resp) => {
          this.loaderRun = false
          this.proformaOpen = true
          this.editableInvoice.invoice = resp.data
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    openIssueProforma (e) {
      if (!this.balanceByInvoices.taxInvoiceNumber) {
        this.setPositionPopup(e, 'proformaButton')
        return
      }
      if (this.disableProforma) return
      const invoiceId = get(this.soaInvoice, 'id', '')
      this.$emit('openIssueProforma', this.issueProformaServices, invoiceId)
    },
    getDataBalance () {
      this.loaderRun = true
      const invoiceId = get(this.soaInvoice, 'id', '')
      SoaApi.getSoaInvoice(invoiceId)
        .then(({data: {
          status,
          services,
          autoSoas,
          issueProformaServices,
          ...invoiceData
        }}) => {
          this.loaderRun = false
          this.balanceByInvoices = invoiceData
          this.issueProformaServices = issueProformaServices
          this.disabledButton = !this.balanceByInvoices.taxInvoiceNumber
          this.statusInvoice = this.getStatusInvoice(status)
          this.servicesBalance = services.map(item => item)
          const list = services.concat(autoSoas)
          this.balanceList = list.map(item => {
            item.name = item.name || item.description
            return item
          })
          this.currentStatus = this.defaultStatus
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    getColorByInvoiceStatus () {
      const id = get(this.statusInvoice, 'id', 0)
      const status = (id === 3) ? 'green' : (id === 1 || id === 0) ? 'red' : 'none'
      return status
    },
    getStatusInvoice (status) {
      return this.invoiceStatus.find(item => item.id === status)
    },
    saveBalance () {
      const invoiceId = get(this.soaInvoice, 'id', '')
      this.$emit('saveBalance', invoiceId)
    }
  },
  beforeMount () {
    this.getDataBalance()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../sass/variables";
  @import "../../../../../../sass/mixins";

  .bb-balance-soa-wrapper {
    margin: auto;
    min-width: 100%;
  }

  .bb-balance-soa{
    @include global-font;
    background: $color-white;
    border-radius: 5px;
    min-width: 700px;

    &__line {
      height: 1px;
      width: 100%;
      margin-bottom: 35px;
      background-color: $color-mercury;
    }

    &-select {
      width: 260px;
      font-size: 13px;
      line-height: 16px;
      font-weight: normal;
      cursor: pointer;

      &__warning {
        text-align: center;
        color: $color-pomegranate;
        padding-top: 10px;
        font-weight: bold;
      }

      &__option {
        width: 8px;
        height: 8px;
        margin-right: 6px;
        display: inline-block;
        border-radius: 50%;
        white-space: nowrap;

        &_green {
          color: $color-japanese-laurel;
        }

        &_red {
          color: $color-pomegranate;
        }

        &_completed {
          background-color: $color-pomegranate;
        }

        &_consumed {
          background-color: $color-japanese-laurel;
        }

        &_open {
          background-color: $color-jaffa;
        }
      }
    }

    &-header {
      margin-bottom: 26px;

      &-title {
        font-size: 18px;
        font-weight: bold;
        line-height: 21px;
        color: $color-black;
      }
    }

    &-variants {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin-bottom: 20px;

      &__button {
        border: 1px solid $color-accent;
        border-radius: 5px;
        padding: 8px 20px;
        margin-top: 14px;
        color: $color-accent;
        cursor: pointer;
        font-weight: 600;
        font-size: 13px;
        line-height: 16px;

        &_disabled {
          cursor: not-allowed;
          border: 1px solid $color-gray;
          color: $color-gray;
        }
      }

      &-popup {
        display: grid;
        z-index: 2;
        grid-row-gap: 10px;
        max-width: 458px;
        position: fixed;
        background: $color-white;
        box-shadow: 0 0 12px rgba($color-black, 0.12);
        border-radius: 5px;
        color: $color-black;
        padding: 12px;
        pointer-events: none;

        &__text {
          font-size: 12px;
          line-height: 14px;
          font-weight: 500;
          text-transform: capitalize;
        }
      }

      &__tax-invoice {
        font-weight: bold;
        font-size: 14px;
        line-height: 17px;

        &_color {
          color: $color-pomegranate;
        }
      }

      &-status {
        &-circle {
          width: 8px;
          height: 8px;
          margin-right: 6px;
          display: inline-block;
          background-color: $color-jaffa;
          border-radius: 50%;
        }

        &-text {
          font-weight: normal;
          font-size: 14px;
          line-height: 17px;
          color: $color-jaffa;
        }
      }

      &-received {
        display: inline-flex;
        flex-direction: column;
        color: $color-black;
        font-weight: bold;
        font-size: 14px;
        line-height: 17px;

        &__item {
          display: grid;
          padding-bottom: 12px;
          grid-template-columns: minmax(95px, 164px) auto;
        }

        &_text-end {
          text-align: end;
        }

        &__due {
          display: grid;
          grid-template-columns: minmax(61px, 164px) auto;
          justify-content: space-between;
          text-transform: capitalize;

          &_green {
            font-weight: bold;
            font-size: 14px;
            width: max-content;
            line-height: 17px;
            padding: 5px 10px;
            background-color: rgba($color-japanese-laurel, 0.2);
            border-radius: 4px;
            text-align: center;
            color: $color-japanese-laurel;
          }

          &_red {
            font-weight: bold;
            font-size: 14px;
            width: max-content;
            line-height: 17px;
            padding: 5px 10px;
            text-align: center;
            background-color: rgba($color-pomegranate, 0.2);
            border-radius: 4px;
            color: $color-pomegranate;
          }

          &_none {
            font-weight: bold;
            font-size: 14px;
            line-height: 17px;
            text-align: end;
          }
        }
      }
    }

    &-table {
      display: grid;

      &-row {
        position: relative;
        display: grid;
        align-items: center;
        width: 100%;
        border-top: 1px solid $color-wild-sand;
        min-height: 52px;
        grid-gap: 5px;
        grid-template-columns: 1fr 4fr 1fr 1.3fr 1fr;
        transition: 0.3s;

        &:before {
          content: '';
          position: absolute;
          top: auto;
          left: -4px;
          width: 0;
          height: 100%;
          background-color: $color-accent;
          border-radius: 4px 0 0 4px;
          transition: 0.3s;
        }

        &-cell {
          word-break: break-word;
          font-size: 14px;
          line-height: 17px;

          &_title {
            font-weight: 600;
            font-size: 12px;
            line-height: 14px;
            color: $color-accent;
          }

          &_bold {
            font-weight: bold;
          }

          &_outgoing {
            height: 52px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: $color-cinderella;
          }
        }
      }

      &-row:first-child {
        border-top: none;
      }
    }

    &-button {
      position: sticky;
      bottom: -1px;
      background-color: $color-white;
      padding-top: 35px;
      z-index: 9;
      display: flex;
      justify-content: flex-end;

      &-size {
        padding: 13px 37px;
        font-weight: 600;
        font-size: 13px;
        line-height: 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/BalanceByInvoices.vue